import { VFC } from 'react';
import { Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';

interface HomeButtonProps {
  onClick?: () => void;
}

export const HomeButton: VFC<HomeButtonProps> = ({ onClick }) => (
  <Button className="home-button" icon={<HomeOutlined />} size="middle" type="primary" onClick={() => onClick?.()} />
);
